import type { JSX } from "preact";

interface LogoProps {
  size?: number;
  class?: string;
}

export function Logo({ size = 32, class: cls }: LogoProps): JSX.Element {
  // Geometry must stay in sync with src/client/favicon.svg — update both files together
  return (
    <svg viewBox="0 0 32 32" width={size} height={size} class={cls}
         aria-hidden="true" fill="none">
      {/* accent tile — --color-accent */}
      <rect x="0" y="0" width="32" height="32" rx="8" fill="var(--color-accent)" />
      {/* envelope body — --color-accent-600 */}
      <path d="M6 11l10 7 10-7v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2z" fill="var(--color-accent-600)" />
      {/* envelope/M flap — --color-fg-on-accent */}
      <path d="M6 11l10 7 10-7" stroke="var(--color-fg-on-accent)" stroke-width="2"
            stroke-linejoin="round" fill="none" />
    </svg>
  );
}
